import { CustomerNumber } from '../types';

// eslint-disable-next-line import/prefer-default-export
export function calculateCreditRemaining(customerNumber: CustomerNumber): number {
    return customerNumber.minsOwed > 0 ? -customerNumber.minsOwed : customerNumber.minsPaid;
}
